/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ScrimmageRequestAcceptRejectEnum {
    A = 'A',
    R = 'R',
    M = 'M'
}


export function ScrimmageRequestAcceptRejectEnumFromJSON(json: any): ScrimmageRequestAcceptRejectEnum {
    return ScrimmageRequestAcceptRejectEnumFromJSONTyped(json, false);
}

export function ScrimmageRequestAcceptRejectEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrimmageRequestAcceptRejectEnum {
    return json as ScrimmageRequestAcceptRejectEnum;
}

export function ScrimmageRequestAcceptRejectEnumToJSON(value?: ScrimmageRequestAcceptRejectEnum | null): any {
    return value as any;
}

